/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type RouteTypeEnum = 1 | 2 | 3;

export const RouteTypeEnum = {
    NUMBER_1: 1 as RouteTypeEnum,
    NUMBER_2: 2 as RouteTypeEnum,
    NUMBER_3: 3 as RouteTypeEnum
};
